import {
  branch,
  compose, lifecycle,
  renderComponent,
  withState,
} from 'recompose';

import Success from '../Success';

export default compose(
  withState('isSuccess', 'setIsSuccess', false),
  lifecycle({
    componentDidUpdate(prevProps) {
      const isHandedSuccessfully = !this.props.isError && prevProps.pending && !this.props.pending;
      if (isHandedSuccessfully) {
        this.props.setIsSuccess(true);
        setTimeout(() => {
          this.props.setIsSuccess(false);
        }, 5000);
      }
    },
  }),
  branch(
    ({ isSuccess }) => isSuccess,
    renderComponent(Success),
  ),
);
